import { render, staticRenderFns } from "./selectClass.vue?vue&type=template&id=1ce92768&"
import script from "./selectClass.vue?vue&type=script&lang=js&"
export * from "./selectClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports